import { render, staticRenderFns } from "./HuchaCrear.vue?vue&type=template&id=2e3fe923&scoped=true"
import script from "./HuchaCrear.vue?vue&type=script&lang=js"
export * from "./HuchaCrear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3fe923",
  null
  
)

export default component.exports